import React, { useEffect, useState } from "react";
import { Menubar } from "primereact/menubar";
import sksLogo from "../../images/sksLogo.png";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "primereact/button";
import {TextField} from "@mui/material";
import { OverlayPanel } from "primereact/overlaypanel";
import { useRef } from "react";
import { Divider } from "primereact/divider";

const NavBar = ({ products, searchTerm, setSearchTerm }) => {
    const [user, setUser] = useState(null);
    const op = useRef(null);
    useEffect(() => {
        const storedUser = localStorage.getItem("loggedInUser");
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);
    const handleLogout = () => {
        localStorage.removeItem("loggedInUser");
        navigate("/login");
        window.location.reload();
    };
    const userInitial = user?.firstName?.charAt(0).toUpperCase();
    const navigate = useNavigate();
    const location = useLocation();
    const [activeItem, setActiveItem] = useState("");
    const [showSearch, setShowSearch] = useState(false);
    const isMobile = window.innerWidth <= 440;
    const isMobile360 = window.innerWidth <= 360;
    const isTablet = window.innerWidth >= 768 && window.innerWidth <= 834;
    const isOrdersPage = location.pathname === "/orders";
    const getTotalCartItems = () => {
        let total = 0;
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key.startsWith("cartItem-")) {
                const item = JSON.parse(localStorage.getItem(key));
                total += Number(item?.productQuantity || 0);
            }
        }
        return total;
    };
    const TotalPurchaseItem = getTotalCartItems();
    const items = [
        { label: "HOME", path: "/", command: () => handleNavigation("HOME", "/") },
        { label: "PRODUCTS", path: "/products", command: () => handleNavigation("PRODUCTS", "/products") },
        { label: "ABOUT US", path: "/about-us", command: () => handleNavigation("ABOUT US", "/about-us") },
        { label: "CONTACT US", path: "/contact-us", command: () => handleNavigation("CONTACT US", "/contact-us") },
        ...(isMobile ? [
            { separator: true },
            {
                template: () => (
                    <div className="d-flex align-items-center gap-2 px-3 py-2">
                        {user ? (
                            <>
                                <div className="br-50 text-white d-flex justify-content-center align-items-center fw-bold bg-green" onClick={(e) => op.current.toggle(e)} style={{width: "35px", height: "35px"}}>
                                    {userInitial}
                                </div>
                            </>
                        ) : (
                                <div onClick={() => navigate(user ? "/profile" : "/login")} className="d-flex align-items-center gap-2 px-3 py-2">
                                    <i className="pi pi-user"></i>
                                </div>
                        )}
                        <span className="fw-bold">
                            {user ? `${user.firstName} ${user.lastName}` : "Login"}
                        </span>
                    </div>
                )
            },
            ...(user ? [
                {
                    label: "Order History",
                    icon: "pi pi-shopping-bag",
                    command: () => navigate("/orderhistory")
                },
                {
                    label: "Logout",
                    icon: "pi pi-sign-out",
                    command: handleLogout,
                }
            ] : [])
        ] : [])
    ];

    const handleNavigation = (label, path) => {
        setActiveItem(label);
        navigate(path);
    };

    useEffect(() => {
        const currentPath = location.pathname;
        const activeMenuItem = items.find((item) => item.path === currentPath);
        if (activeMenuItem) {
            setActiveItem(activeMenuItem.label);
        }
    }, [location.pathname]);

    const start = (
            <div className={`logo ${showSearch && isTablet ? "logo-tablet-search" : ""}`} >
                {!(showSearch && isMobile) && (
                    <img src={sksLogo} width="160px" alt="SKS Logo" loading="lazy"/>
                )}
            </div>
    );

    const filteredProducts = products?.filter(product =>
        product.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const end = isOrdersPage ? null : (
        <div className="d-flex align-items-center position-relative">
            {showSearch && (
                <div className="position-relative">
                    <TextField label="Search products..." variant="outlined" size="small" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} fullWidth sx={{ maxWidth: 400 }}/>
                    {searchTerm && filteredProducts?.length > 0 && (
                        <ul style={{position: "absolute", top: "100%", left: 0, right: 0, background: "#fff", border: "1px solid #ccc", maxHeight: "200px", overflowY: "auto", zIndex: 1000, padding: "0.5rem", margin: 0, listStyle: "none"}}>
                            {filteredProducts.map(product => (
                                <li key={product.id} onClick={() => {navigate(`/product-details/${product.id}`, { state: { product } });setShowSearch(false);setSearchTerm("");}}
                                    style={{padding: "0.4rem 0.6rem", cursor: "pointer", borderBottom: "1px solid #eee"}}>
                                    {product.name}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            )}
            {isMobile360 && !showSearch ?(
                <Button icon="pi pi-search" rounded text  aria-label="Search" className="icon-btn no-bg" style={{marginLeft: "15rem"}} onClick={() => setShowSearch(prev => !prev)}/>
            ):(
                <Button icon="pi pi-search" rounded text  aria-label="Search" className="icon-btn me-2 no-bg" onClick={() => setShowSearch(prev => !prev)}/>
            )}
            {!isMobile && (
                user ? (
                        <>
                            <div className=" br-50 bg-green text-white d-flex justify-content-center align-items-center fw-bold me-2" onClick={(e) => op.current.toggle(e)} style={{width: "35px", height: "35px", cursor: "pointer"}}>
                                {userInitial}
                            </div>
                            <OverlayPanel ref={op}>
                                <div style={{width:"220px"}}>
                                    <div className="d-flex align-items-center mb-2">
                                        <div className="br-50 bg-green text-white d-flex justify-content-center align-items-center me-2" style={{width:"35px", height:"35px",}}>
                                            {userInitial}
                                        </div>
                                        <div>
                                            <div className="fw-bold">
                                                {user.firstName} {user.lastName}
                                            </div>
                                            <div style={{fontSize:"12px",color:"#777"}}>
                                                {user.email}
                                            </div>
                                        </div>
                                    </div>
                                    <Divider/>
                                    <div className="user-menu-item" onClick={()=>navigate("/profile")}>
                                        Profile
                                    </div>
                                    <div className="user-menu-item" onClick={()=>navigate("/orderhistory")}>
                                        Order History
                                    </div>
                                    <div className="user-menu-item">
                                        Settings
                                    </div>
                                    <Divider/>
                                    <div className="user-menu-item text-danger" onClick={handleLogout}>
                                        Logout
                                    </div>
                                </div>
                            </OverlayPanel>
                        </>
                    ) : (
                        <Button icon="pi pi-user" rounded text className="icon-btn me-2 no-bg " onClick={() => navigate('/login')}/>
                )
            )}
            <div style={{ position: "relative" }} className="me-3">
                <Button icon="pi pi-shopping-bag" rounded text  aria-label="Cart" className="icon-btn me-2 no-bg" onClick={() => navigate('/cart-details')}/>
                {TotalPurchaseItem > 0 &&(
                    <span style={{position: "absolute",top: "21px", right: "10px", background: "red", color: "white", borderRadius: "50%", padding: "3px 5px", fontSize: "10px", fontWeight: "light", lineHeight: "1",}}>{TotalPurchaseItem}</span>
                )}
            </div>
        </div>
    );

    return (
        <div className="fixed-top br-0 py-0">
            <Menubar model={isOrdersPage ? [] : items.map((item) => ({...item, className: activeItem === item.label ? "active-menu-item" : "",}))} start={start} end={end}/>
        </div>
    );
};
export default NavBar;
